import CountryText from '../Elements/CountryText';
import RedirectLinkComponent from '../Elements/RedirectLinkComponent';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import IobLineItem from './IobLineItem';
import React from 'react';

class TpIobLineItemFieldworkFees extends IobLineItem {
  static FieldsToShowInDataTable() {
    return [
      { label: 'Third-Party Job ID', orderById: 'ThirdPartyJobId', data: TpIobLineItemFieldworkFees.idFunction },
      { label: 'Type', orderById: 'Type', data: 'Type' },
      { label: 'Status', orderById: 'TpJobStatus', data: 'TpJobStatus' },
      {
        label: 'Country',
        orderById: 'ThirdPartyLocationCountry',
        data: (item) => <CountryText Code={item.ThirdPartyLocationCountry} />,
      },
      { label: 'Amount', orderById: 'Amount', data: 'Amount' },
      {
        label: ' ',
        orderById: '',
        data: IobLineItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
        className: 'text-center',
      },
    ];
  }

  static idFunction(item) {
    return (
      <RedirectLinkComponent
        path='tpjobs'
        tooltipText={item.ThirdPartyJobId}
        text={item.ThirdPartyJobId}
        isFigmaStyle={true}
        keyValuePairs={[{ key: 'ThirdPartyJobId', value: item.ThirdPartyJobId }]}
      />
    );
  }
}
export default TpIobLineItemFieldworkFees;
